export default __webpack_public_path__ + "static/media/_calculator_cpa.f8fddd50.svg";